import React, { Component } from 'react';
import {withRouter} from 'react-router-dom';

import Cards from './Cards.js';

class CardsContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {selectedLeaderboard:null};
        this.onLaunchSurvey = this.onLaunchSurvey.bind(this);
        this.onClickLeaderboard = this.onClickLeaderboard.bind(this);
        this.onConfirmLeaderboard = this.onConfirmLeaderboard.bind(this);
        this.onCancelLeaderboard= this.onCancelLeaderboard.bind(this);
    }

    onLaunchSurvey(survey, micro) {
        var surveyId = survey.id;
        if(micro) {
            this.props.history.push('/msurvey/'+surveyId);
        } else {
            this.props.history.push('/survey/'+surveyId);
        }
    }

    onClickLeaderboard(leaderboard) {
        if(leaderboard) {
            if(leaderboard.invitations > 0) {
                this.props.history.push('/team-challenge/invitations');
            } else {
                this.setState({selectedLeaderboard:leaderboard});
            }
        }
    }

    onConfirmLeaderboard() {
        var leaderboard = this.state.selectedLeaderboard;
        if(leaderboard) {
            this.props.history.push('/selectteam/'+leaderboard.id);
        }
    }

    onCancelLeaderboard() {
        this.setState({selectedLeaderboard:null});
    }

    render() {
        return <Cards cards={this.props.cards}
                      selectedLeaderboard={this.state.selectedLeaderboard}
                      onLaunchSurvey={this.onLaunchSurvey}
                      onClickLeaderboard={this.onClickLeaderboard}
                      onConfirmLeaderboard={this.onConfirmLeaderboard}
                      onCancelLeaderboard={this.onCancelLeaderboard}>
                    {this.props.children}
                </Cards>;
                    
    }

}

export default withRouter(CardsContainer);



// WEBPACK FOOTER //
// ./src/modules/cards/CardsContainer.js